// extracted by mini-css-extract-plugin
export var brand = "_2r-9";
export var compact = "_2r-6";
export var extraSmall = "_2r-7";
export var icon = "_2r-0";
export var large = "_2r-4";
export var light = "_2r-1";
export var medium = "_2r-5";
export var outline = "_2r-b";
export var primaryDark = "_2r-a";
export var primaryLight = "_2r-8";
export var primaryModern = "_2r-c";
export var success = "_2r-2";
export var successSolid = "_2r-3";